<template>
    <div>
        <input
                type="text"
                class="form-control"
                @blur="blur_search"
                v-model="search_string"
                :placeholder="trans('search', null)"
        >

        <div class="warehouse-inventory-form__autocomplete-result-container" v-show="found_products.length > 0">
            <div class="warehouse-inventory-form__autocomplete-result__body">
                <ul class="list-group">
                    <li
                            v-for="product in found_products"
                            @click="goto_product(product)"
                            class="list-group-item warehouse-inventory-form__result-item"
                    >
                        {{product.name}}
                    </li>
                </ul>
            </div>
        </div>

        <div class="warehouse-inventory-form__brands">
            <div v-for="brand in brands" class="btn btn-default" @click="load_brand(brand.id)">{{brand.title}}</div>
        </div>

        <div class="warehouse-inventory-form__loaded-container" v-show="loaded_brand.id">
            <form :action="action_url" method="POST" ref="form">
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" name="brand_id" :value="loaded_brand.id">
            <div class="warehouse-inventory-form__save-button-container">
                <button type="submit" class="btn btn-primary" v-text="trans('save_button', null)"></button>
            </div>
            <br>

            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        {{ loaded_brand.title }}
                    </h4>
                </div>
                <div class="panel-body">
                    <table class="table table-striped b-warehouse__table">
                        <thead>
                        <tr>
                            <th class="col-md-2" v-text="trans('grade')"></th>
                            <th class="col-md-3" v-text="trans('pack')"></th>
                            <th class="col-md-4" v-text="trans('provider')"></th>
                            <th class="col-md-3" v-text="trans('vendor_code')"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="product in loaded_brand.products" :id="'product-' + product.id">
                            <!-- Сорт -->
                            <td class="col-md-3">
                                <span class="b-warehouse__product-name" :data-product="product.id">
                                    {{ product.name }}
                                </span>
                            </td>
                            <td colspan="3" class="col-md-9">
                                <table class="b-warehouse__variants-table">
                                    <tbody>
                                    <tr v-for="variant in product.variants">
                                        <!-- Упаковка -->
                                        <td class="col-md-3"><span>{{ variant.title }}</span></td>
                                        <td colspan="2" class="col-md-9">
                                            <table class="b-warehouse__variants-table">
                                                <tbody>
                                                <tr v-for="supplier in suppliers">
                                                    <!-- Поставщик -->
                                                    <td class="col-md-7"><span class="pull-right">{{ supplier.title}}</span></td>
                                                    <!-- Артикул -->
                                                    <td class="col-md-5">
                                                        <input
                                                                class="form-control input-sm b-warehouse__new-count"
                                                                type="text"
                                                                min="0"
                                                                step="1"
                                                                :name="'data[' + variant.id + '][' + supplier.id + ']'"
                                                                v-model="supplier_articles[variant.id][supplier.id]"
                                                        >
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="warehouse-inventory-form__save-button-container">
                <button type="submit" class="btn btn-primary" v-text="trans('save_button', null)"></button>
            </div>
            </form>
        </div>
    </div>
</template>

<script>
import * as Functions from '../Functions';

export default {
    props: ['brands', 'suppliers', 'translations'],
    data: function () {
        return {
            csrf: '',
            search_string: '',
            found_products: [],
            loaded_brand: {},
            supplier_articles: [],
            cache: {},
            is_now_scrolling: false,
            now_scrolling_to_product_id: 0,
            action_url: "/admin/warehouse/article_maps/store_articles",
        };
    },
    mounted: function () {
        let token = document.querySelector('#token').getAttribute('content');
        Vue.http.headers.common['X-CSRF-TOKEN'] = token;
        this.csrf = token;
    },
    updated: function () {
        if (this.is_now_scrolling) {
            this.scroll_to_product();
            this.is_now_scrolling = false;
        }
    },
    methods: {
        trans(name, path = 'stock') {
            return Functions.trans(this.translations, name, path);
        },
        blur_search: function () {
            setTimeout(function () {
                this.found_products = [];
            }, 1);
        },
        autocomplete: function (search_string) {
            this.clear();

            if (search_string.length < 3) {
                return;
            }

            if (search_string in this.cache) {
                this.found_products = this.get_from_cache(search_string);
                return;
            }

            let self = this;
            this.$http
                .post('/warehouse/article_maps/autocomplete', {search_string: search_string})
                .then(function (response) {
                    self.found_products = response.data.products;
                    self.put_to_cache(search_string, response.data.products);
                });
        },
        load_brand: function (brand_id, product_id = 0) {
            this.clear();

            let self = this;
            this.$http
                .post('/warehouse/article_maps/load_brand', {id: brand_id})
                .then(function (response) {
                    self.loaded_brand = response.data.brand;
                    self.supplier_articles = response.data.supplier_articles;
                    if (product_id) {
                        self.run_scroll_process(product_id);
                    }
                });
        },
        goto_product: function (product) {
            this.load_brand(product.brand_id, product.id);
        },
        run_scroll_process: function (product_id) {
            this.is_now_scrolling = true;
            this.now_scrolling_to_product_id = product_id;
        },
        scroll_to_product: function () {
            let product_id = this.now_scrolling_to_product_id;
            let element = this.$el.querySelector("#product-" + product_id);
            element.style.backgroundColor = '#dedede';
            document.body.scrollTop = element.offsetTop;
        },
        clear: function () {
            this.found_products = [];
            this.loaded_brand = {};
        },
        get_from_cache: function (key) {
            return this.cache[key];
        },
        put_to_cache: function (key, search_result) {
            this.cache[key] = search_result;
        }
    },
    watch: {
        'search_string': function (val) {
            this.autocomplete(val);
        }
    }
};
</script>
